module.exports = __webpack_public_path__ + "static/media/pdp_popup_left_arrow_icon.fdba62bb.svg";